declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    dataLayer?: any[];
    __loadTracking?: () => void;
  }
}

export function trackPageView() {
  if (typeof window !== "undefined" && window.fbq) {
    try { window.fbq("track", "PageView"); } catch {}
  }
}

export function trackLead() {
  if (typeof window !== "undefined" && window.fbq) {
    try { window.fbq("track", "Lead"); } catch {}
  }
}

/**
 * Notifies GTM of a form submission. Pushes a `formSubmit` Custom Event to
 * dataLayer AND dispatches a native bubbling `submit` event on the form so
 * GTM's auto Form Submit trigger (gtm.formSubmit) reliably picks it up — even
 * when the page handles submission via JS/fetch with preventDefault.
 */
export function trackFormSubmit(form: HTMLFormElement | null, formName: string) {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "formSubmit",
      formName,
      formId: form?.id || "",
      formClasses: form?.className || "",
      formAction: form?.action || window.location.href,
      pagePath: window.location.pathname,
    });
  } catch {}
  try {
    if (form && !form.dataset.gtmDispatching) {
      form.dataset.gtmDispatching = "1";
      form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      delete form.dataset.gtmDispatching;
    }
  } catch {}
}

export function trackCompleteRegistration() {
  if (typeof window !== "undefined" && window.fbq) {
    try { window.fbq("track", "CompleteRegistration"); } catch {}
  }
}

export function loadTracking() {
  if (typeof window !== "undefined" && window.__loadTracking) {
    try { window.__loadTracking(); } catch {}
  }
}
